<template>
  <ModalComponent :id="id" title="Edit User" widthMax="max-w-md">
    <template #body>
      <Form @submit="acceptModal">
        <div class="flex flex-col px-6 py-4">
          <InputWithLabel label="Username *" name="username" :value="user.username" />
          <InputWithLabel label="Name *" name="name" :value="user.name" />
          <div class="mb-6">
            <label for="role" class="block mb-2 text-sm font-medium">Role *</label>
            <SelectSearch
              :data="roles"
              optionsValue="label"
              optionsKey="value"
              v-model:formControlName="user.role"
              placeholder="Select Role"
            />
          </div>
        </div>
        <ModalFooter>
          <template #accept>
            <ButtonComponent :loading="loading">Accept</ButtonComponent>
          </template>
        </ModalFooter>
      </Form>
    </template>
  </ModalComponent>
</template>
<script>
import ButtonComponent from "@/components/ButtonComponent.vue";
import InputWithLabel from "@/components/InputWithLabel.vue";
import ModalComponent from "@/components/ModalComponent.vue";
import ModalFooter from "@/components/ModalFooter.vue";
import SelectSearch from "@/components/SelectSearch.vue";
import axios from "@/config";
import { useErrorStore, useModalStore, useUserStore } from "@/store";
import { Form } from "vee-validate";
import { reactive, ref, watchEffect } from "vue";

export default {
  props: {
    id: Number,
    userid: String,
  },
  components: {
    ButtonComponent,
    InputWithLabel,
    ModalComponent,
    ModalFooter,
    SelectSearch,
    Form,
  },
  setup(props) {
    const roles = [
      { label: "User", value: "user" },
      { label: "Admin", value: "admin" },
    ];

    const user = reactive({
      username: "",
      name: "",
      role: "",
    });

    const loading = ref(false);
    const userid = ref("");

    const modal = useModalStore();
    const errorStore = useErrorStore();
    const userStore = useUserStore();

    watchEffect(async () => {
      console.log(props.userid);
      userid.value = props.userid;
      if (userid.value != "") {
        console.log(userid.value);
        await userStore.getUserById(userid.value);
        user.username = userStore.userById.username;
        user.name = userStore.userById.name;
        user.role = userStore.userById.role;
      }
    });

    const acceptModal = async (value) => {
      const { username, name } = value;
      loading.value = true;
      try {
        await axios.put(`user/${userid.value}`, {
          username: username,
          name: name,
          role: user.role,
        });
        loading.value = false;
        userStore.page = 1;
        userStore.offset = 0;
        userStore.q = "";
        modal.closeModal();
        await userStore.getAllUser({});
        userStore.length = userStore.users.count;
      } catch (error) {
        loading.value = false;
        modal.closeModal();
        errorStore.open = true;
        errorStore.retry = false;
        errorStore.message = error.response.data.message;
      }
    };

    return {
      roles,
      user,
      loading,
      acceptModal,
    };
  },
};
</script>
<style></style>
